import { render, staticRenderFns } from "./GetPng.vue?vue&type=template&id=3cf63a3c"
import script from "./GetPng.vue?vue&type=script&lang=js"
export * from "./GetPng.vue?vue&type=script&lang=js"
import style0 from "./GetPng.vue?vue&type=style&index=0&id=3cf63a3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports